import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { SellerPageValidationSchema } from "../../utils/validations";
import { yupResolver } from "@hookform/resolvers/yup";
import MobileInput from "../common/form/MobileInput";
import { handleKeyDown, initializeIntlTelInput } from "../../helpers";
import useTranslationHook from "../hooks/useTranslationHook";
import Input from "../common/form/Input";
import ReactSelect from "../common/ReactSelect";
import { useDispatch, useSelector } from "react-redux";
import { setPropertyType } from "../../redux/action/sellerAction";
import { resetFilter, setFilter } from "../../redux/slice/discoverSlice";
import Slider from "react-slick";
import useWindowDimensions from "../hooks/useWindowDimension";
import { listWithUs } from "../../redux/action/faqAction";
import { Trans } from "react-i18next";
const SellWithUsView = () => {
    const inputRef = useRef(null);
    const { t } = useTranslationHook();
    const dispatch = useDispatch();
    const [state, setState] = useState({
        countryCode: "",
    });
    const windowDimension = useWindowDimensions();
    const formRef = useRef(null);
    const [isFormVisible, setIsFormVisible] = useState(false);
    const scrollToForm = () => {
        formRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });
    };

    const {
        register,
        handleSubmit,
        reset,
        control,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(SellerPageValidationSchema),
    });
    const propertyTypes = useSelector((state) => state.seller.propertyTypes);
    const property_type = useSelector((state) => state.discover.property_type);
    const [isFixed, setIsFixed] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop =
                window.pageYOffset || document.documentElement.scrollTop;
            const windowHeight = window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;

            const distanceFromBottom =
                documentHeight - (scrollTop + windowHeight);

            if (scrollTop > 200 && distanceFromBottom > 400) {
                setIsFixed(true);
            } else {
                setIsFixed(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll();

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsFormVisible(entry.isIntersecting);
            },
            {
                threshold: 0.2,
            }
        );

        if (formRef.current) {
            observer.observe(formRef.current);
        }

        return () => {
            if (formRef.current) {
                observer.unobserve(formRef.current);
            }
        };
    }, []);

    useEffect(() => {
        initializeIntlTelInput({
            inputRef,
            countryCode: "971",
            setState,
        });
        if (!propertyTypes || propertyTypes?.length === 0)
            dispatch(setPropertyType());
        return () => {
            const scriptToRemove =
                document.getElementById("intlTelInputScript");
            if (scriptToRemove) scriptToRemove.remove();

            const stylesheetToRemove = document.getElementById(
                "intlTelInputStylesheet"
            );
            if (stylesheetToRemove) stylesheetToRemove.remove();
            dispatch(resetFilter());
        };
        //eslint-disable-next-line
    }, []);

    const onSubmit = (data) => {
        dispatch(
            listWithUs({ ...data, phone_country_code: state.countryCode }, t)
        );
        reset();
    };
    const slidesToScrollCount = (width) => {
        if (width <= 768) return 1;
        else if (width > 768 && width <= 1024) return 2;
        else if (width > 1024 && width <= 1280) return 2;
        else return 3;
    };
    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: slidesToScrollCount(windowDimension.width),
        slidesToScroll: slidesToScrollCount(windowDimension.width),
    };

    const services = [
        {
            title: t("Professional Photography"),
            img: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c",
        },
        {
            title: t("Property Inspection"),
            img: "https://images.unsplash.com/photo-1581092160607-ee22621dd758",
        },
        {
            title: t("Professional Photography"),
            img: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c",
        },
        {
            title: t("Property Inspection"),
            img: "https://images.unsplash.com/photo-1581092160607-ee22621dd758",
        },
        {
            title: t("Dedicated Advisor"),
            img: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d",
        },
        {
            title: t("Dedicated Advisor"),
            img: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d",
        },
    ];

    const SliderSettings = {
        className: "center",
        centerMode: true,
        infinite: true,
        centerPadding: "120px",
        slidesToShow: 3,
        speed: 500,

        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    centerPadding: "50px",
                },
            },
        ],
    };

    return (
        <>
            <section className="seller-banner">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5 col-md-8 col-xs-12">
                            <h3>
                                <Trans
                                    i18nKey="sellSmarter"
                                    components={{ highlight: <span /> }}
                                />
                            </h3>
                            <h5>
                                {t(
                                    "Mazad Estate’s auction platform empowers property owners with strategic pricing, live competitive bidding, expert support, and fully transparent outcomes."
                                )}
                            </h5>
                            <button
                                className="btn btn-primary btn-lg"
                                onClick={scrollToForm}
                            >
                                {t("Sell with us")}
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            <section className="seller-traditional-wrap">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="text-center mb-4">
                                <h3>
                                    {t(
                                        "Why Auction Instead of Traditional Listing?"
                                    )}
                                </h3>
                                <p>
                                    {t(
                                        "Auctions create competition, transparency, and faster sales maximizing your property's true market value."
                                    )}
                                </p>
                            </div>
                            <div className="item">
                                <div className="block">
                                    <ul className="seller-traditional-list">
                                        <li>
                                            <figure>
                                                <img
                                                    src="img/seller-icon-1.svg"
                                                    alt="Competitive Bidding Icon"
                                                />
                                            </figure>
                                            <figcaption>
                                                <h6>{"Competitive Bidding"}</h6>
                                                <p>
                                                    {t(
                                                        "Multiple buyers competing increases your final sale value significantly."
                                                    )}
                                                </p>
                                            </figcaption>
                                        </li>
                                        <li>
                                            <figure>
                                                <img
                                                    src="img/seller-icon-2.svg"
                                                    alt="Competitive Bidding Icon"
                                                />
                                            </figure>
                                            <figcaption>
                                                <h6>{t("Faster Timeline")}</h6>
                                                <p>
                                                    {
                                                        "Clear deadlines mean faster decision cycles and quicker sales."
                                                    }
                                                </p>
                                            </figcaption>
                                        </li>
                                        <li>
                                            <figure>
                                                <img
                                                    src="img/seller-icon-3.svg"
                                                    alt="Competitive Bidding Icon"
                                                />
                                            </figure>
                                            <figcaption>
                                                <h6>
                                                    {t("Full Transparency")}
                                                </h6>
                                                <p>
                                                    {t(
                                                        "Real-time visibility into bids vs private, unpredictable offers."
                                                    )}
                                                </p>
                                            </figcaption>
                                        </li>
                                        <li>
                                            <figure>
                                                <img
                                                    src="img/seller-icon-4.svg"
                                                    alt="Competitive Bidding Icon"
                                                />
                                            </figure>
                                            <figcaption>
                                                <h6>
                                                    {t("Data-Backed Valuation")}
                                                </h6>
                                                <p>
                                                    {t(
                                                        "True market valuation based on real demand, not guesswork."
                                                    )}
                                                </p>
                                            </figcaption>
                                        </li>
                                    </ul>
                                </div>

                                <div className="block">
                                    <ul className="seller-traditional-check">
                                        <li>
                                            <h6>{t("Mazad Platfrom")}</h6>
                                        </li>
                                        <li>
                                            <figure>
                                                <img
                                                    src="img/check-fill.svg"
                                                    alt="check Icon"
                                                />
                                            </figure>
                                            <figcaption>
                                                {t(
                                                    "Competitive bids decide price"
                                                )}
                                            </figcaption>
                                        </li>
                                        <li>
                                            <figure>
                                                <img
                                                    src="img/check-fill.svg"
                                                    alt="check Icon"
                                                />
                                            </figure>
                                            <figcaption>
                                                {t(
                                                    "Fast timelines & clear process"
                                                )}
                                            </figcaption>
                                        </li>
                                        <li>
                                            <figure>
                                                <img
                                                    src="img/check-fill.svg"
                                                    alt="check Icon"
                                                />
                                            </figure>
                                            <figcaption>
                                                {t("Real-time transparency")}
                                            </figcaption>
                                        </li>
                                        <li>
                                            <figure>
                                                <img
                                                    src="img/check-fill.svg"
                                                    alt="check Icon"
                                                />
                                            </figure>
                                            <figcaption>
                                                {t("Data-backed valuation")}
                                            </figcaption>
                                        </li>
                                        <li>
                                            <figure>
                                                <img
                                                    src="img/check-fill.svg"
                                                    alt="check Icon"
                                                />
                                            </figure>
                                            <figcaption>
                                                {t(
                                                    "Verified, serious buyers only"
                                                )}
                                            </figcaption>
                                        </li>
                                    </ul>

                                    <ul className="seller-traditional-uncheck">
                                        <li>
                                            <h6>{t("Traditional Sale")}</h6>
                                        </li>
                                        <li>
                                            <figure>
                                                <img
                                                    src="img/close-fill.svg"
                                                    alt="check Icon"
                                                />
                                            </figure>
                                            <figcaption>
                                                {t(
                                                    "Fixed asking price, negotiation needed"
                                                )}
                                            </figcaption>
                                        </li>
                                        <li>
                                            <figure>
                                                <img
                                                    src="img/close-fill.svg"
                                                    alt="check Icon"
                                                />
                                            </figure>
                                            <figcaption>
                                                {
                                                    "Slow, uncertain, unpredictable"
                                                }
                                            </figcaption>
                                        </li>
                                        <li>
                                            <figure>
                                                <img
                                                    src="img/close-fill.svg"
                                                    alt="check Icon"
                                                />
                                            </figure>
                                            <figcaption>
                                                {t(
                                                    "Private, unpredictable offers"
                                                )}
                                            </figcaption>
                                        </li>
                                        <li>
                                            <figure>
                                                <img
                                                    src="img/close-fill.svg"
                                                    alt="check Icon"
                                                />
                                            </figure>
                                            <figcaption>
                                                {t(
                                                    "Owner guesswork / agent estimates"
                                                )}
                                            </figcaption>
                                        </li>
                                        <li>
                                            <figure>
                                                <img
                                                    src="img/close-fill.svg"
                                                    alt="check Icon"
                                                />
                                            </figure>
                                            <figcaption>
                                                {t(
                                                    "Mixed quality of buyer interest"
                                                )}
                                            </figcaption>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="auction-preparation-wrap">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-6 col-md-8 col-sm-12">
                            <div className="auction-top">
                                <div className="text">
                                    {t("Auction Preparation")}
                                </div>
                                <h3>{t("Backed By & Trusted By")}</h3>
                                <p>
                                    {t(
                                        "Join thousands of property owners who have successfully sold through our auction platform."
                                    )}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-12">
                            <div className="item">
                                <div className="block">
                                    <h2>30%+</h2>
                                    <p>
                                        <Trans i18nKey="higherClosingPrice" />
                                    </p>
                                </div>

                                <div className="block">
                                    <h2>95%</h2>
                                    <p>
                                        <Trans i18nKey="activeBids" />
                                    </p>
                                </div>

                                <div className="block">
                                    <h2>5,000+</h2>
                                    <p>
                                        <Trans
                                            i18nKey="verifiedBidders"
                                            components={{ bold: <strong /> }}
                                        />
                                    </p>
                                </div>

                                <div className="block">
                                    <h2>
                                        <Trans i18nKey="sevenDays" />
                                    </h2>
                                    <p>
                                        <Trans i18nKey="avgFirstBid" />
                                    </p>
                                </div>
                            </div>
                            <ul>
                                <li>
                                    <h6>{t("Corporate Clients")}</h6>
                                </li>
                                <li>
                                    <h6>{t("Real Estate Partners")}</h6>
                                </li>
                                <li>
                                    <h6>{t("Marketing Networks")}</h6>
                                </li>
                                <li>
                                    <h6>{t("Verified Buyers")}</h6>
                                </li>
                                <li>
                                    <h6>{t("Property Developers")}</h6>
                                </li>
                                <li>
                                    <h6>{t("Investment Firms")}</h6>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <section className="selling-flow-wrap">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 position-relative">
                            <div className="text">
                                <p>{t("How It Works")}</p>

                                <h3>{t("Simple Auction Selling Flow")}</h3>

                                <p>
                                    {t(
                                        "From submission to sale, we guide you through every step of the auction process."
                                    )}
                                </p>

                                <button
                                    className="btn btn-primary"
                                    onClick={scrollToForm}
                                >
                                    {t("Get started")}
                                </button>
                            </div>

                            <div className="flow-chart">
                                <div className="chart">
                                    <img src="img/graph-line.png" alt="" />
                                </div>

                                <div className="flow flow-1">
                                    <div className="dot"></div>
                                    <div className="num">1</div>
                                    <h6>{t("Submit Your Property")}</h6>
                                    <p>
                                        {t(
                                            "Fill out our simple form with your property details and auction preferences."
                                        )}
                                    </p>
                                </div>

                                <div className="flow flow-2">
                                    <div className="dot"></div>
                                    <div className="num">2</div>
                                    <h6>{t("Inspection & Photography")}</h6>
                                    <p>
                                        {t(
                                            "Schedule inspection, snagging, and professional photography (optional but recommended)."
                                        )}
                                    </p>
                                </div>

                                <div className="flow flow-3">
                                    <div className="dot"></div>
                                    <div className="num">3</div>
                                    <h6>{t("Valuation & Strategy")}</h6>
                                    <p>
                                        {t(
                                            "Set reserve price, timing, and target audience with your account manager."
                                        )}
                                    </p>
                                </div>

                                <div className="flow flow-4">
                                    <div className="dot"></div>
                                    <div className="num">4</div>
                                    <h6>{t("Property Goes Live")}</h6>
                                    <p>
                                        {t(
                                            "Your property is listed on our auction platform with full marketing support."
                                        )}
                                    </p>
                                </div>

                                <div className="flow flow-5">
                                    <div className="dot"></div>
                                    <div className="num">5</div>
                                    <h6>{t("Bidding Event")}</h6>
                                    <p>
                                        {t(
                                            "Watch live as verified buyers compete with transparent real-time bids."
                                        )}
                                    </p>
                                </div>

                                <div className="flow flow-6">
                                    <div className="dot"></div>
                                    <div className="num">6</div>
                                    <h6>{t("Accept & Close")}</h6>
                                    <p>
                                        {t(
                                            "Accept the best bid and proceed to transaction completion with full support."
                                        )}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="personal-support-wrap">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="personal-banner">
                                <div className="text">
                                    <p>{t("Personal Support")}</p>

                                    <h3>{t("Your Auction Strategy Expert")}</h3>

                                    <p>
                                        {t(
                                            "Every property owner is assigned a dedicated account manager who becomes your trusted partner throughout the entire auction journey. From setting the right reserve price to coordinating marketing and managing buyer communications—we handle it all."
                                        )}
                                    </p>
                                </div>

                                <button
                                    className="btn btn-white"
                                    onClick={scrollToForm}
                                >
                                    {t("Get Your Dedicated Manager")}
                                </button>
                            </div>

                            <div className="item">
                                <div className="block">
                                    <ul>
                                        <li>
                                            <figure>
                                                <img
                                                    src="img/personal-icon-1.svg"
                                                    alt="Reserve Price Strategy Icon"
                                                />
                                            </figure>
                                            <figcaption>
                                                <h6>
                                                    {t(
                                                        "Reserve Price Strategy"
                                                    )}
                                                </h6>
                                                <p>
                                                    {t(
                                                        "Expert guidance to set the optimal reserve price that maximizes value while ensuring sale."
                                                    )}
                                                </p>
                                            </figcaption>
                                        </li>

                                        <li>
                                            <figure>
                                                <img
                                                    src="img/personal-icon-2.svg"
                                                    alt="Marketing & Targeting Icon"
                                                />
                                            </figure>
                                            <figcaption>
                                                <h6>
                                                    {t("Marketing & Targeting")}
                                                </h6>
                                                <p>
                                                    {t(
                                                        "Strategic marketing campaigns and buyer targeting to attract qualified bidders."
                                                    )}
                                                </p>
                                            </figcaption>
                                        </li>

                                        <li>
                                            <figure>
                                                <img
                                                    src="img/personal-icon-3.svg"
                                                    alt="Timing Optimization Icon"
                                                />
                                            </figure>
                                            <figcaption>
                                                <h6>
                                                    {t("Timing Optimization")}
                                                </h6>
                                                <p>
                                                    {t(
                                                        "Recommendations on the best timing and auction format for your property."
                                                    )}
                                                </p>
                                            </figcaption>
                                        </li>

                                        <li>
                                            <figure>
                                                <img
                                                    src="img/personal-icon-4.svg"
                                                    alt="Full Communication Icon"
                                                />
                                            </figure>
                                            <figcaption>
                                                <h6>
                                                    {t("Full Communication")}
                                                </h6>
                                                <p>
                                                    {t(
                                                        "Handles all buyer inquiries, updates, and negotiations on your behalf."
                                                    )}
                                                </p>
                                            </figcaption>
                                        </li>

                                        <li>
                                            <figure>
                                                <img
                                                    src="img/personal-icon-5.svg"
                                                    alt="Price Maximization Icon"
                                                />
                                            </figure>
                                            <figcaption>
                                                <h6>
                                                    {t("Price Maximization")}
                                                </h6>
                                                <p>
                                                    {t(
                                                        "Focused on achieving the highest possible sale price through expert tactics."
                                                    )}
                                                </p>
                                            </figcaption>
                                        </li>
                                    </ul>
                                </div>

                                <div className="block">
                                    <div className="quote">
                                        <div className="icon">
                                            <img
                                                src="img/quote-icon.svg"
                                                alt="quote Icon"
                                            />
                                        </div>

                                        <h3>
                                            {t(
                                                '"My account manager was incredible. They helped me set the perfect reserve price and the auction exceeded my expectations. I sold 12% above what I expected in just 14 days."'
                                            )}
                                        </h3>

                                        <h5>
                                            {t("Ahmed K.")}
                                            <span>
                                                {t("Villa Owner, Dubai Marina")}
                                            </span>
                                        </h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="platform-wrap">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="gray-box">
                                <div className="platform-banner">
                                    <div className="block">
                                        <p>{t("Technology Advantage")}</p>

                                        <h3>
                                            {t("Our Platform & App Provides")}
                                        </h3>

                                        <p>
                                            {t(
                                                "Cutting-edge technology designed to give you complete control and visibility throughout your auction journey."
                                            )}
                                        </p>
                                    </div>

                                    <div className="block">
                                        <img
                                            className="mac-pic"
                                            src="img/platform.png"
                                            alt="platform"
                                        />
                                    </div>
                                </div>

                                <div className="platform-list">
                                    <div className="block">
                                        <div className="icon">
                                            <img
                                                src="img/platform-1.svg"
                                                alt="platform"
                                            />
                                        </div>
                                        <h6>{t("Live Bidding Panel")}</h6>
                                        <p>
                                            {t(
                                                "Real-time auction room with transparent bidding activity and countdown timers."
                                            )}
                                        </p>
                                    </div>

                                    <div className="block">
                                        <div className="icon">
                                            <img
                                                src="img/platform-2.svg"
                                                alt="platform"
                                            />
                                        </div>
                                        <h6>{t("Smart Buyer Matching")}</h6>
                                        <p>
                                            {t(
                                                "AI-powered system invites qualified, verified buyers interested in your property type."
                                            )}
                                        </p>
                                    </div>

                                    <div className="block">
                                        <div className="icon">
                                            <img
                                                src="img/platform-3.svg"
                                                alt="platform"
                                            />
                                        </div>
                                        <h6>{t("Instant Notifications")}</h6>
                                        <p>
                                            {t(
                                                "Real-time updates on bids, buyer interest, and auction milestones via app and email."
                                            )}
                                        </p>
                                    </div>

                                    <div className="block">
                                        <div className="icon">
                                            <img
                                                src="img/platform-4.svg"
                                                alt="platform"
                                            />
                                        </div>
                                        <h6>{t("Owner Dashboard")}</h6>
                                        <p>
                                            {t(
                                                "Track interest levels, view bid history, and access valuation insights all in one place."
                                            )}
                                        </p>
                                    </div>

                                    <div className="block">
                                        <div className="icon">
                                            <img
                                                src="img/platform-5.svg"
                                                alt="platform"
                                            />
                                        </div>
                                        <h6>{t("Direct Communication")}</h6>
                                        <p>
                                            {t(
                                                "Easy messaging with your dedicated account manager throughout the auction process."
                                            )}
                                        </p>
                                    </div>

                                    <div className="block">
                                        <div className="icon">
                                            <img
                                                src="img/platform-6.svg"
                                                alt="platform"
                                            />
                                        </div>
                                        <h6>{t("Mobile App Access")}</h6>
                                        <p>
                                            {t(
                                                "Manage your auction from anywhere with our fully-featured mobile application."
                                            )}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="auction-wrap">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 col-md-10 col-xs-12">
                            <div className="text-center">
                                <p>{t("Auction Preparation")}</p>
                                <h3>
                                    {t(
                                        "On demand Services That Prepare You for Auction"
                                    )}
                                </h3>
                                <p>
                                    {t(
                                        "Maximize your property's value with our comprehensive suite of pre-auction services."
                                    )}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <Slider {...SliderSettings}>
                    {services.map((item, index) => (
                        <div key={index} className="slide-item">
                            <div className="service-card">
                                <figure>
                                    <img
                                        className="slide-fixed"
                                        src="/img/trans-3x2.png"
                                        alt=""
                                    />
                                    <img
                                        className="slide-img"
                                        src={item.img}
                                        alt={item.title}
                                    />
                                </figure>

                                <h5 className="service-title">
                                    {t(item.title)}
                                </h5>
                            </div>
                        </div>
                    ))}
                </Slider>
            </section>

            <section className="quote-wrap">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h3>{t("What Property Owners Say")}</h3>

                            <ul className="quote-slider">
                                <Slider {...settings}>
                                    <li>
                                        <div className="box">
                                            <div className="icon">
                                                <img
                                                    src="img/quote-icon.svg"
                                                    alt="quote Icon"
                                                />
                                            </div>
                                            <p>
                                                {t(
                                                    '"I listed through auction and sold 12% above expected price in 14 days. The transparency was incredible."'
                                                )}
                                            </p>
                                            <h6>
                                                {t("Sarah M.")}
                                                <span>
                                                    {t(
                                                        "Apartment Owner, Downtown"
                                                    )}
                                                </span>
                                            </h6>
                                        </div>
                                    </li>

                                    <li>
                                        <div className="box">
                                            <div className="icon">
                                                <img
                                                    src="img/quote-icon.svg"
                                                    alt="quote Icon"
                                                />
                                            </div>
                                            <p>
                                                {t(
                                                    '"The competitive bidding environment got me offers I never would have received through traditional listing."'
                                                )}
                                            </p>
                                            <h6>
                                                {t("Mohammed R.")}
                                                <span>
                                                    {t(
                                                        "Villa Owner, Palm Jumeirah"
                                                    )}
                                                </span>
                                            </h6>
                                        </div>
                                    </li>

                                    <li>
                                        <div className="box">
                                            <div className="icon">
                                                <img
                                                    src="img/quote-icon.svg"
                                                    alt="quote Icon"
                                                />
                                            </div>
                                            <p>
                                                {t(
                                                    '"From inspection to final sale, the team handled everything. I just watched the bids come in."'
                                                )}
                                            </p>
                                            <h6>
                                                {t("Jennifer L.")}
                                                <span>
                                                    {t(
                                                        "Commercial Property Owner"
                                                    )}
                                                </span>
                                            </h6>
                                        </div>
                                    </li>

                                    <li>
                                        <div className="box">
                                            <div className="icon">
                                                <img
                                                    src="img/quote-icon.svg"
                                                    alt="quote Icon"
                                                />
                                            </div>
                                            <p>
                                                {t(
                                                    '"The competitive bidding environment got me offers I never would have received through traditional listing."'
                                                )}
                                            </p>
                                            <h6>
                                                {t("Mohammed R.")}
                                                <span>
                                                    {t(
                                                        "Villa Owner, Palm Jumeirah"
                                                    )}
                                                </span>
                                            </h6>
                                        </div>
                                    </li>
                                </Slider>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <section className="auction-support-wrap" ref={formRef}>
                <div className="container">
                    <form
                        onSubmit={handleSubmit(onSubmit)}
                        autoComplete="off"
                        autoCapitalize="off"
                    >
                        <div className="row justify-content-center">
                            <div className="col-lg-6 col-md-8 col-sm-12">
                                <p>{t("Start Your Auction")}</p>
                                <h3>{t("List Your Property on Auction")}</h3>
                                <p>{t("List Your Property on Auction")}</p>

                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="mb-3">
                                            <Input
                                                type="text"
                                                id="name"
                                                className="form-control"
                                                placeholder={t(
                                                    "Enter your full name"
                                                )}
                                                label={t("Full Name") + t(" *")}
                                                register={register}
                                                errors={errors}
                                                {...register("name")}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="mb-3">
                                            <Input
                                                type="text"
                                                id="email"
                                                className="form-control"
                                                placeholder={t(
                                                    "Enter your email"
                                                )}
                                                label={t("Email") + t(" *")}
                                                register={register}
                                                errors={errors}
                                                {...register("email")}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="mb-3">
                                            <MobileInput
                                                type={"tel"}
                                                id={"phone_number"}
                                                className={"form-control"}
                                                placeholder={t("Phone Number")}
                                                label={
                                                    t("Phone Number") + t(" *")
                                                }
                                                // labelClassname={item.labelClassname}
                                                inputRef={inputRef}
                                                register={register}
                                                name={"phone_number"}
                                                // validationRules={{
                                                //     required:
                                                //         "This field is required",

                                                //     validate: () => {
                                                //         const iti = window
                                                //             .$(inputRef.current)
                                                //             .intlTelInput();
                                                //         const isValid =
                                                //             iti.intlTelInput(
                                                //                 "isValidNumber"
                                                //             );
                                                //         if (!isValid) {
                                                //             return "Please enter a valid phone number";
                                                //         }
                                                //         return true;
                                                //     },
                                                // }}
                                                errors={errors}
                                                onKeyDown={handleKeyDown}
                                                maxLength={15}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="mb-3">
                                            <Input
                                                type="text"
                                                id="name"
                                                className="form-control"
                                                placeholder={t("City, Area")}
                                                label={t("Property Location")}
                                                register={register}
                                                errors={errors}
                                                {...register(
                                                    "property_location"
                                                )}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="mb-3">
                                            <label htmlFor="">
                                                {t("Property Type") + t(" *")}
                                            </label>
                                            <ReactSelect
                                                name={"property_type"}
                                                isMulti={false}
                                                isClearable={false}
                                                control={control}
                                                options={propertyTypes}
                                                isSearchable={true}
                                                placeholder={t("Property Type")}
                                                className="select"
                                                value={property_type}
                                                onChange={(dropDownValues) => {
                                                    let value =
                                                        dropDownValues.value;
                                                    dispatch(
                                                        setFilter({
                                                            ["property_type"]:
                                                                value,
                                                        })
                                                    );
                                                }}
                                            />
                                            {errors?.["property_type"] && (
                                                <span className="text-danger">
                                                    {t(
                                                        errors["property_type"]
                                                            .message
                                                    )}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                    <button className="btn btn-primary btn-full">
                                        {t("List with us")}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </section>

            {!isFormVisible ? (
                <section
                    className={`sell-withus-wrap ${isFixed ? "fixed" : ""}`}
                >
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-6 col-md-8 col-sm-12">
                                <h3>
                                    {t("Sell with us")}
                                    <button
                                        className="btn btn-primary btn-lg"
                                        onClick={scrollToForm}
                                    >
                                        {t("Sell with us")}
                                    </button>
                                </h3>
                            </div>
                        </div>
                    </div>
                </section>
            ) : (
                <></>
            )}
        </>
    );
};

export default SellWithUsView;
